// BackButton.js
import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const BackButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(-1); // This tells React Router to go back to the previous page
  };

  return (
    <button onClick={handleClick} style={{ padding: '10px 20px', cursor: 'pointer' }} className='btn btn-light-outlined'> 
    <div style={{color:"#E82561"}}>

      <FaArrowLeft/>
    </div>
    </button>
  );
};

export default BackButton;
